import { WarehouseDiscount } from 'entities/Warehouse';
import { getLocalizedString } from 'shared/utils/helpers/JSONLocalization';

interface Duration {
  duration: string;
  allDurationEqual: boolean;
  description: string;
}

export const parseDiscountData = (discount?: WarehouseDiscount): Nullable<Duration> => {
  if (!discount) {
    return null;
  }

  const parts = discount.discounts.split(',').map((s) => s.split('-'));

  const lastDurationNumber = parseInt(parts.at(-1)?.[0] || '0', 10) || 'all';
  const values = parts.map(([, v]) => v.replace('%', ''));
  const allDurationEqual = values.every((v) => v === values[0]);

  return {
    duration: String(lastDurationNumber),
    allDurationEqual,
    description: getLocalizedString(discount.description),
  };
};
